import React, { type FC, type PropsWithChildren } from 'react';
import { FlexBox } from '@is24at/react-ui-core';
import styles from './KeyFacts.scss';

const KeyFacts: FC<PropsWithChildren> = ({ children }) => (
  <FlexBox
    tag="section"
    alignItems="start"
    spacing={0}
    direction="column"
    className={styles['key-facts']}
  >
    {children}
  </FlexBox>
);

export default KeyFacts;
